<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Paskal</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="1400px">
        <template v-slot:activator="{ on }">
          <v-layout row wrap justify-end>
            <v-flex shrink>
              <v-btn
                color="primary"
                dark
                class="mb-2"
                v-on="on"
                @click="btnClicked('Andromeda')"
              >+ Nuevo Ingreso Andromeda</v-btn>
            </v-flex>
            <v-flex shrink>
              <v-btn
                color="primary"
                dark
                class="mb-2"
                v-on="on"
                @click="btnClicked('Aquila')"
              >+ Nuevo Ingreso Aquila</v-btn>
            </v-flex>
            <v-flex shrink>
              <v-btn
                color="primary"
                dark
                class="mb-2"
                v-on="on"
                @click="btnClicked('Argus')"
              >+ Nuevo Ingreso Argus</v-btn>
            </v-flex>
            <v-flex shrink>
              <v-btn
                color="primary"
                dark
                class="mb-2"
                v-on="on"
                @click="btnClicked('Aries')"
              >+ Nuevo Ingreso Aries</v-btn>
            </v-flex>
          </v-layout>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <template>
                <div>
                  <v-form v-model="valid">
                    <v-data-table
                      disable-initial-sort
                      :headers="headersModal"
                      :items="items"
                      :pagination.sync="pagination"
                      class="elevation-2"
                    >
                      <template v-slot:items="props">
                        <td>{{ props.item.nave }}</td>
                        <td>{{ props.item.sector }}</td>
                        <td>
                          <v-text-field v-model="props.item['Riego Total Paskal']" label required></v-text-field>
                        </td>
                        <td>
                          <v-text-field v-model="props.item['CE De Paskal']" label required></v-text-field>
                        </td>
                        <td>
                          <v-text-field v-model="props.item['Drenaje mL Paskal']" label required></v-text-field>
                        </td>
                        <td>
                          <v-text-field v-model="props.item['Drenaje % Paskal']" label required></v-text-field>
                        </td>
                        <td class="justify-center">
                          <v-btn small color="green">
                            <v-icon color="white" @click="submitItem(props)">check</v-icon>
                          </v-btn>
                        </td>
                      </template>
                    </v-data-table>
                  </v-form>
                </div>
              </template>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancelar</v-btn>
            <!-- <v-btn color="blue darken-1" flat @click="save">Guardar</v-btn> -->
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>

    <v-data-table
      :headers="headers"
      :items="entry"
      :pagination.sync="pagination"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td>{{ props.item.nave }}</td>
        <td class="text-xs-right">{{ props.item.sector }}</td>
        <td class="text-xs-right">{{ props.item['Riego Total Paskal'] }}</td>
        <td class="text-xs-right">{{ props.item['CE De Paskal'] }}</td>
        <td class="text-xs-right">{{ props.item['Drenaje mL Paskal'] }}</td>
        <td class="text-xs-right">{{ props.item['Drenaje % Paskal'] }}</td>
        <td class="text-xs-right">{{ new Date(props.item.createdAt).toLocaleString() }}</td>
        <td class="justify-center layout px-0">
          <v-icon small @click="deleteItem(props.item)">delete</v-icon>
        </td>
      </template>
    </v-data-table>
    <br />

    <div class="card">
      <v-toolbar class="toolbar">
        <v-toolbar-title class="text-xs-center">
          <h1>Paskal App</h1>
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-layout wrap>
        <v-flex xs12 sm6 md6>
          <form
            method="post"
            enctype="multipart/form-data"
            target="dummyframe"
            id="usrform"
            ref="form"
            v-on:submit.prevent="onSubmit"
            class="form"
          >
            <div class="dropbox">
              <h2>
                <i class="far fa-image"></i> Arrastra o haz click para subir una imagen:
              </h2>
              <br />
              <image-uploader
                id="file-input"
                type="file"
                name="file"
                :autoRotate="true"
                outputFormat="verbose"
                :preview="true"
                :className="['input-file', { 'fileinput--loaded' : hasImage }]"
                :capture="false"
                accept="video/*, image/*"
                doNotResize="['gif', 'svg']"
                @input="setImage"
                @onUpload="startImageResize"
                @onComplete="endImageResize"
                ref="pictureInput"
              ></image-uploader>
            </div>
            <br />
            <v-btn class="info" type="submit" value="submit">Aceptar</v-btn>
          </form>
          <iframe width="0" height="0" border="0" name="dummyframe" id="dummyframe"></iframe>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <br />
          <v-data-table disable-initial-sort :headers="headers2" :items="posts" class="elevation-1">
            <template v-slot:items="props">
              <td>
                <v-img :src="props.item.url" aspect-ratio="2" class="photo"></v-img>
              </td>

              <!-- <td class="text-xs-left">{{ props.item.user }}</td> -->
              <td class="text-xs-left">{{ props.item.createdAt }}</td>
              <!-- <td class="text-xs-left">{{ props.item.location }}</td> -->
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    Andromeda: [
      {
        nave: "Andromeda 1",
        sector: 1
      },
      {
        nave: "Andromeda 4",
        sector: 3
      },
      {
        nave: "Andromeda 7",
        sector: 6
      }
    ],
    Aquila: [
      {
        nave: "Aquila 2",
        sector: 2
      },
      {
        nave: "Aquila 7",
        sector: 6
      },
      {
        nave: "Aquila 8",
        sector: 7
      },
      {
        nave: "Aquila 9",
        sector: 8
      },
      {
        nave: "Aquila 11",
        sector: 9
      }
    ],
    Argus: [
      {
        nave: "Argus 10",
        sector: 4
      },
      {
        nave: "Argus 2",
        sector: 5
      }
    ],
    Aries: [
      {
        nave: "Aries 1",
        sector: 1
      },
      {
        nave: "Aries 2",
        sector: 2
      }
    ],
    // sector: [ 1,2,3,4,5,6,7,8,9,10 ],
    pagination: {
      page: 1,
      rowsPerPage: 30,
      totalItems: 0
    },
    dialog: false,
    headers: [
      {
        text: "Nave",
        align: "left",
        sortable: false,
        value: "nave"
      },
      { text: "Sector Riego", value: "nave", align: "right" },
      {
        text: "Riego Total Paskal",
        value: "Riego Total Paskal",
        align: "right"
      },
      { text: "CE De Paskal", value: "CE De Paskal", align: "right" },
      { text: "Drenaje mL Paskal", value: "Drenaje mL Paskal", align: "right" },
      { text: "Drenaje % Paskal", value: "Drenaje % Paskal", align: "right" },
      { text: "Fecha", value: "date", align: "center" },
      { text: "Eliminar", value: "name", sortable: false, align: "center" }
    ],
    headersModal: [
      {
        text: "Nave",
        align: "left",
        sortable: false,
        value: "nave"
      },
      { text: "Sector Riego", value: "nave" },
      { text: "Riego Total Paskal", value: "Riego Total Paskal" },
      { text: "CE De Paskal", value: "CE De Paskal" },
      { text: "Drenaje mL Paskal", value: "Drenaje mL Paskal" },
      { text: "Drenaje % Paskal", value: "Drenaje % Paskal" },
      // { text: 'Fecha', value: 'date' },
      { text: "Aceptar", value: "name", sortable: false }
    ],
    headers2: [
      {
        text: "Fotografía",
        align: "left",
        value: "url"
      },
      { text: "Fecha", value: "date" }
      // { text: 'Archivo', value: 'name' },
    ],
    entry: [],
    editedIndex: -1,
    editedItem: {},
    defaultItem: {},
    hasImage: null,
    name: null,
    form: null,
    posts: []
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Ingreso" : "Edit Item";
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  created() {
    this.new();
  },

  beforeMount() {
    this.updateTable();
  },
  methods: {
    new() {
      this.editedItem.date = `${new Date().getDate()}/${new Date().getMonth()}/${new Date().getFullYear()}`;
      this.$axios
        .get("/api/PaskalReports/", this.editedItem)
        .then(response => {
          console.log("resp", response);
          this.entry = response.data;
        })
        .catch(e => {
          console.log(e);
        });
    },
    btnClicked(e) {
      console.log(e);
      this.items = this[`${e}`];
    },
    updateTable() {
      this.$forceUpdate();
      this.$axios.get(`/api/PaskalImage/`).then(({ data }) => {
        // console.log(data);
        this.posts = data;
      });
    },

    deleteItem(item) {
      const index = this.entry.indexOf(item);
      const _id = {
        _id: this.entry[this.entry.indexOf(item)]._id
      };
      confirm("¿Estas seguro que quieres eliminar este registro?");
      let r = confirm("¿Estas seguro que quieres eliminar este registro?");
      if (r == true) {
        this.entry.splice(index, 1);
        this.$axios.post("/api/DeletePaskalReports/", _id);
      }
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    submitItem(props) {
      console.log(this.items);
      console.log(props.item);
      console.log(props.item.nave);
      console.log(props.index);

      this.$axios
        .post("/api/PaskalReports/", props.item)
        .then(response => {
          if (response.status === 200) {
            this.items = this.items.filter(function(obj) {
              return obj.nave !== props.item.nave;
              // console.log(this.items)
            });
            alert("Registro enviado!!!");
            this.new();
          }
        })
        .catch(e => {
          console.log(e);
        });
    },

    setImage: function(file) {
      console.log(file);
      this.hasImage = true;
      this.image = file.dataUrl;
      this.name = file.info.name;
      this.form = {};
    },
    startImageResize: function() {},
    endImageResize: function() {},
    onSubmit() {
      alert("Imagen subida!");

      let data = new FormData();
      data.append("name", this.name);
      data.append("file", this.image);
      data.append("form", JSON.stringify(this.form));

      const url = "/api/PaskalImage";
      let parse = this.$axios.post(url, data);
    }
  }
};
</script>

<style scoped>
.v-card {
  padding: 30px !important;
}

.form {
  padding: 40px 40px 40px 40px;
}

.img-preview {
  width: 50% !important;
}

#dummyframe {
  opacity: 0.1;
}
</style>
